import { nodeNameToFactoryId } from "../compiler/utils/nodeNameToFactoryId";
import { ChildNodesProps } from "../parser/definition/types/ChildNodesProps";
import { getNameFromIdentifierChunk } from "../parser/definition/utils/getNameFromIdentifier";
import { SourceChildNodes } from "./types/SourceChildNodes";

export function convertChildNodesPropsToChildNodes(childNodeProps: ChildNodesProps<any, any>): SourceChildNodes {
    let sourceChildNodes: SourceChildNodes = {};
    for (let childNodePropName of Object.keys(childNodeProps)) {
        const childNodeId = nodeNameToFactoryId(childNodePropName);
        sourceChildNodes[childNodeId] = {
            id: childNodeId,
            name: childNodePropName,
            description: childNodePropName,
            sourceNodeId: nodeNameToFactoryId(childNodeProps[childNodePropName].nodeName),
            dependencies: {},
            initialState: childNodeProps[childNodePropName].params
        }
    }

    return sourceChildNodes
}